import { type AssetMetadataWriter } from '@analysis/use-cases';
import { type IDataField } from '@telespot/domain';
import { CloudFunctions } from '@telespot/sdk';

export class CloudAssetMetadataWriter implements AssetMetadataWriter {
  async save(assetId: string, data: IDataField): Promise<void> {
    await CloudFunctions.saveAssetMetadata(assetId, data);
  }
}
